import { AdInsertionType } from '../../addons/ad-insertion-type';
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { PlaybackType, StreamVendor } from '../../core/player/playout-data';
import { TestingOverrides } from '../../core/services/testing-overrides';
export function shouldUseMediaTailor(adInsertionConfig, playbackType, deviceType, playoutData) {
    if (!(adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : adInsertionConfig.vac) || !adInsertionConfig.mediaTailor) {
        return false;
    }
    if (deviceType === DeviceType.Android && playbackType === PlaybackType.SingleLiveEvent) {
        return true;
    }
    if (deviceType === DeviceType.WebMaf && playbackType === PlaybackType.SingleLiveEvent) {
        var _playoutData_cdns__streamInfo;
        var streamVendor = (_playoutData_cdns__streamInfo = playoutData.cdns[0].streamInfo) === null || _playoutData_cdns__streamInfo === void 0 ? void 0 : _playoutData_cdns__streamInfo.vendor;
        switch(streamVendor){
            case StreamVendor.Harmonic:
                return true;
            case StreamVendor.IStreamPlanet:
            case StreamVendor.Unknown:
                return false;
            default:
                return false;
        }
    }
    return useMediaTailorAdInsertionOverride(adInsertionConfig, playbackType);
}
function useMediaTailorAdInsertionOverride(mediaTailorOverrides, playbackType) {
    if (TestingOverrides.adInsertionOverride === AdInsertionType.MediaTailor) {
        return true;
    }
    if (!mediaTailorOverrides) {
        return false;
    }
    if (mediaTailorOverrides.mediaTailorAdInsertionOverrideLinear && playbackType === PlaybackType.Live) {
        return true;
    }
    if (mediaTailorOverrides.mediaTailorAdInsertionOverrideVod && [
        PlaybackType.VOD,
        PlaybackType.Clip,
        PlaybackType.Preview
    ].includes(playbackType)) {
        return true;
    }
    if (mediaTailorOverrides.mediaTailorAdInsertionOverrideFer && playbackType === PlaybackType.FER) {
        return true;
    }
    return false;
}

//# sourceMappingURL=ad-insertion-selection.js.map